export default __webpack_public_path__ + "static/media/firmwareUpdate.4763fad6.png";